
export const hasVehicleProperties = (jsonData: any): boolean => {
  return !!(jsonData.Main_Picture_URL || 
            jsonData.Stock_Number || 
            jsonData.Year || 
            jsonData.Make || 
            jsonData.Model || 
            jsonData.Price || 
            jsonData.Mileage || 
            jsonData.VDP_URL ||
            jsonData.Trim ||
            jsonData["Exterior Color"] ||
            jsonData.Vehicle_Description_Summary ||
            jsonData.Features ||
            jsonData.CARFAX_URL);
};
